import React, { FC } from "react";
import { IconProps } from "../types";

export const CircledMenu: FC<IconProps> = ({ fill = "gray", ...props }) => {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 13C6.55 13 7 12.55 7 12C7 11.45 6.55 11 6 11C5.45 11 5 11.45 5 12C5 12.55 5.45 13 6 13Z"
        stroke={fill}
        strokeWidth="2"
      />
      <path
        d="M6 7C6.55 7 7 6.55 7 6C7 5.45 6.55 5 6 5C5.45 5 5 5.45 5 6C5 6.55 5.45 7 6 7Z"
        stroke={fill}
        strokeWidth="2"
      />
      <path
        d="M6 19C6.55 19 7 18.55 7 18C7 17.45 6.55 17 6 17C5.45 17 5 17.45 5 18C5 18.55 5.45 19 6 19Z"
        stroke={fill}
        strokeWidth="2"
      />
      <path
        d="M12 13C12.55 13 13 12.55 13 12C13 11.45 12.55 11 12 11C11.45 11 11 11.45 11 12C11 12.55 11.45 13 12 13Z"
        stroke={fill}
        strokeWidth="2"
      />
      <path
        d="M12 7C12.55 7 13 6.55 13 6C13 5.45 12.55 5 12 5C11.45 5 11 5.45 11 6C11 6.55 11.45 7 12 7Z"
        stroke={fill}
        strokeWidth="2"
      />
      <path
        d="M12 19C12.55 19 13 18.55 13 18C13 17.45 12.55 17 12 17C11.45 17 11 17.45 11 18C11 18.55 11.45 19 12 19Z"
        stroke={fill}
        strokeWidth="2"
      />
      <path
        d="M18 13C18.55 13 19 12.55 19 12C19 11.45 18.55 11 18 11C17.45 11 17 11.45 17 12C17 12.55 17.45 13 18 13Z"
        stroke={fill}
        strokeWidth="2"
      />
      <path
        d="M18 7C18.55 7 19 6.55 19 6C19 5.45 18.55 5 18 5C17.45 5 17 5.45 17 6C17 6.55 17.45 7 18 7Z"
        stroke={fill}
        strokeWidth="2"
      />
      <path
        d="M18 19C18.55 19 19 18.55 19 18C19 17.45 18.55 17 18 17C17.45 17 17 17.45 17 18C17 18.55 17.45 19 18 19Z"
        stroke={fill}
        strokeWidth="2"
      />
    </svg>
  );
};
